import { SecurityPolicy } from "landing";
import { NextPage } from "next";
import { NextSeo } from "next-seo";

const SecurityPage: NextPage = () => {
	return (
		<>
			<NextSeo
				title="Mango GIS - Security"
				description="Legal information about Security"
			/>
			<SecurityPolicy />
		</>
	);
};

export default SecurityPage;
